import { render, staticRenderFns } from "./YatraLogo.vue?vue&type=template&id=2e4cfa19&scoped=true&lang=html&"
import script from "./YatraLogo.vue?vue&type=script&lang=js&"
export * from "./YatraLogo.vue?vue&type=script&lang=js&"
import style0 from "./YatraLogo.vue?vue&type=style&index=0&id=2e4cfa19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cfa19",
  null
  
)

export default component.exports